/** 观看时长统计 */
const DEBUG = typeof window !== 'undefined' && window.location.href.indexOf('loggerdebug') > -1
export function computeWatchDur (played = []) {
  let watchDur = 0
  for (let i = 0; i < played.length; i++) {
    if (isNaN(Number(played[i].end)) || isNaN(Number(played[i].begin)) || played[i].begin < 0 || played[i].end < 0 || played[i].end < played[i].begin) {
      continue
    }
    watchDur += (played[i].end - played[i].begin)
  }
  watchDur = parseFloat((watchDur * 1000).toFixed(3))
  return watchDur
}

export function getHostFromUrl (url) {
  if (url === null || url === undefined || url === '') {
    return ''
  }
  const results = url.split('/') // 以“/”进行分割
  let domain = ''
  if (results.length > 3 && results[2]) {
    domain = results[2]
  }
  return domain
}

/***
   *
   */
export function generateSessionId (did) {
  let d = new Date().getTime()
  try {
    did = parseInt(did)
  } catch (e) {
    did = 0
  }
  d += did
  if (window.performance && typeof window.performance.now === 'function') {
    d += window.performance.now() // use high-precision timer if available
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

export function isType (type) {
  return function (value) {
    return Object.prototype.toString.call(value) === `[object ${type}]`
  }
}

export function getValue (key, context) {
  const val = context[key]
  if (val === undefined || val === null) {
    // console.warn(`${key}数值未设置`)
  }
  return val
}

export function getResponseHeaders (xhr) {
  const headerMap = {}
  if (xhr instanceof window.XMLHttpRequest) {
    try {
      const headers = xhr.getAllResponseHeaders()
      // Convert the header string into an array
      // of individual headers
      const arr = headers.trim().split(/[\r\n]+/)
      arr.forEach(function (line) {
        const parts = line.split(': ')
        const header = parts.shift()
        const value = parts.join(': ')
        headerMap[header] = value
      })
    } catch (error) {
    }
  }
  return headerMap
}

export function log (message, ...optionalParams) {
  DEBUG && console.log('[logger]', message, ...optionalParams)
}

/**
 * 获取从浏览器加载当当前的时间差
 */
export function nowTime () {
  try {
    return Math.round(window.performance.now())
  } catch (error) {
    return new Date().getTime()
  }
}

/**
 * 获取浏览器加载位移参考时间戳
 */
export function navigationStart () {
  try {
    return window.performance.timing.navigationStart
  } catch (error) {
    return new Date().getTime()
  }
}

/**
 * 获取当前时间戳
 */
export function curTimestamp () {
  return new Date().getTime()
}

export function formatData (data, model) {
  const ret = {
    ext: data.ext || {},
    data: {}
  }
  Object.keys(data).map(key => {
    if (model[key]) {
      ret.data[model[key]] = data[key]
    } else {
      key !== 'ext' && (ret.ext[key] = data[key])
    }
  })
  return ret
}

export function getXhr (url, options = {}) {
  return new Promise((resolve, reject) => {
    try {
      if (!url) {
        reject(new Error('url is undefined'))
      }
      let dTime = 0
      let tTime = 0
      const result = {}
      const xhr = new window.XMLHttpRequest()
      xhr.open('get', url)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 2) {
          result.headers = getResponseHeaders(xhr)
          result.connectTime = nowTime() - tTime
          result.status = xhr.status
          result.statusText = xhr.statusText
          dTime = nowTime()
        }
        if (xhr.readyState === 1) {
          tTime = nowTime()
        }
      }
      xhr.onload = () => {
        resolve(result)
      }
      xhr.onprogress = (data) => {
        let costTime = nowTime() - dTime
        let speed = 0
        if (costTime < 5) {
          costTime = nowTime() - tTime
        }
        speed = parseInt(data.loaded / 1000 / (costTime / 1000), 10)
        result.speed = speed
        result.costTime = costTime
      }
      xhr.onerror = (e) => {
        reject(e)
      }

      xhr.ontimeout = () => {
        if (!result.status) {
          result.status = -2
        }
        resolve(result)
      }

      xhr.onabort = () => {
        resolve(result)
      }
      xhr.responseType = 'arraybuffer'
      xhr.timeout = options.timeout || 10000
      xhr.setRequestHeader('Range', `bytes=${options.range || '0-1048576'}`)
      xhr.send()
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * 校验当前video的src值是否是空 IE下src为空会获取到当前页面地址去除query的值
 * @param {string}} src
 */
export function checkVideoSrcIsEmpty (src) {
  if (!src || window.location.href.indexOf(src) > -1) {
    return true
  }
  return false
}

export function checkIsEmptySrc (player, appid) {
  if (player.video && Number(player.video.getAttribute('data-empty')) === 1) {
    return true
  }
  if (appid === 1768 && !player.config.dashOpts && !player.config.mp4Opts) {
    return true
  }
  return false
}

export function checkIsBlob (url) {
  return url ? /^blob:/.test(url) : false
}

const KEYMAP = {
  x_response_sinfo: 'x-response-sinfo',
  x_response_cache: 'x-response-cache',
  x_response_cinfo: 'x-response-cinfo'
}

export function transformHeader (headers) {
  if (!headers) {
    return {}
  }
  const newHeaders = {}
  Object.keys(KEYMAP).map(key => {
    if (!headers[key] && typeof KEYMAP[key] === 'string') {
      newHeaders[key] = headers[KEYMAP[key]] || ''
    } else if (!headers[key] && KEYMAP[key] instanceof Array) {
      const finalKey = KEYMAP[key].filter(item => headers[item] !== undefined)
      if (finalKey.length > 0) {
        newHeaders[key] = headers[finalKey[0]]
      } else {
        newHeaders[key] = ''
      }
    }
  })
  return newHeaders
}

export function appendData (org, src) {
  if (!org) {
    return src
  } else if (typeof src === 'string' || typeof src === 'number') {
    return org + '' + src
  } else {
    return src
  }
}

export function parseTempData (curData = {}, data = {}, action = '') {
  Object.keys(data).map(key => {
    if (action === 'append') {
      curData[key] = appendData(curData[key], data[key])
    } else {
      curData[key] = data[key]
    }
  })
  return curData
}
